// src/pages/admin/DashboardAdmin.tsx
import React from "react";
import { Link } from "react-router-dom";

export default function DashboardAdmin() {
  return (
    <div className="relative w-full overflow-x-clip bg-gradient-to-b from-slate-50 to-slate-100">
      {/* Fondos decorativos suaves (no alteran el flujo) */}
      <div className="pointer-events-none absolute inset-x-0 -top-24 -z-10 mx-auto h-[24rem] max-w-5xl rounded-full bg-gradient-to-r from-blue-500/10 via-indigo-500/10 to-fuchsia-500/10 blur-3xl" />
      

      {/* Contenedor central compacto y fluido */}
      <div className="mx-auto max-w-[1100px] sm:max-w-3xl lg:max-w-5xl xl:max-w-6xl px-3 sm:px-6 py-6 sm:py-8">
        <h1 className="text-center text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
          Panel de Administración
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-center text-slate-600">
          Gestiona bancos, proveedores, órdenes y gastos desde un solo lugar.
        </p>

        {/* Grid: 1 → 2 → 3 cols, sin desbordes */}
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
          <DashboardCard
            to="/admin/bancos"
            title="Cuentas/Bancos"
            desc="Registrar bancos o tarjetas desde los que se pagan los gastos."
            emoji="🏦"
            gradient="from-blue-500 to-indigo-500"
          />
          <DashboardCard
            to="/admin/proveedores"
            title="Proveedores"
            desc="Administrar proveedores de servicios o refacciones."
            emoji="🧾"
            gradient="from-rose-500 to-orange-500"
          />
          <DashboardCard
            to="/admin/odes"
            title="Órdenes de Compra" // ⬅️ CORREGIDO
            desc="Registrar y consultar OCs, y montos a cobrar." // ⬅️ CORREGIDO
            emoji="📋"
            gradient="from-amber-500 to-yellow-500"
          />
          <DashboardCard
            to="/admin/gastos"
            title="Gastos"
            desc="Asignar gasto a proveedor, banco y OC." // ⬅️ CORREGIDO
            emoji="💸"
            gradient="from-emerald-600 to-teal-500"
          />
          <DashboardCard
            to="/admin/reportes"
            title="Reportes"
            desc="Ver gastos por fecha, banco, proveedor u OC." // ⬅️ CORREGIDO
            emoji="📊"
            gradient="from-fuchsia-600 to-violet-600"
          />
          <DashboardCard
            to="/admin/gasto-form"
            title="Nuevo Gasto"
            desc="Registrar gasto con archivos y evidencia."
            emoji="📝"
            gradient="from-cyan-600 to-sky-500"
          />
        </div>
      </div>
    </div>
  );
}

function DashboardCard({
  to,
  title,
  desc,
  emoji,
  gradient,
}: {
  to: string;
  title: string;
  desc: string;
  emoji: string;
  gradient: string;
}) {
  return (
    <Link
      to={to}
      className="group relative min-w-0 overflow-hidden rounded-2xl bg-white/70 backdrop-blur ring-1 ring-slate-200 shadow-sm transition
                 hover:shadow-xl hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      <div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${gradient}`} aria-hidden />
      <div className="p-6">
        <div className="mb-3 flex items-center gap-3">
          <div
            className={`grid h-10 w-10 place-items-center rounded-xl bg-gradient-to-br ${gradient} text-white shadow`}
            aria-hidden
          >
            <span className="text-lg">{emoji}</span>
          </div>
          <h2 className="text-xl font-semibold text-slate-900">{title}</h2>
        </div>
        <p className="text-sm leading-relaxed text-slate-600">{desc}</p>
        <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-slate-800">
          Entrar
          <span className="translate-x-0 transition-transform duration-200 group-hover:translate-x-1">→</span>
        </div>
      </div>
      {/* brillo suave al hover */}
      <div
        className={`pointer-events-none absolute -right-12 -top-12 h-24 w-24 rounded-full bg-gradient-to-br ${gradient} opacity-0 blur-2xl transition-opacity duration-200 group-hover:opacity-20`}
        aria-hidden
      />
    </Link>
  );
}